import BdcEdi from "../components/Bdc/Edi";

const BdcEdiPage = () => <BdcEdi />;

export default BdcEdiPage;
